import script from "./tenant-logs.vue?vue&type=script&setup=true&lang=js"
export * from "./tenant-logs.vue?vue&type=script&setup=true&lang=js"

import "./tenant-logs.vue?vue&type=style&index=0&id=f2fc0cd4&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2fc0cd4"]])

export default __exports__